<template>
  <div>
    <v-list two-line>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <span class='font-weight-light grey--text text--darken-3'>
              {{ $store.state.auth.profile.name_display }}
            </span>
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class='font-weight-light grey--text'>
            </span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list dense nav>
      <v-list-item :to="{ name: 'MyTasks' }">
        <v-list-item-action>
          <v-icon color='info'>{{ $icons.tasks.icon }}</v-icon>
          <v-badge
            v-if='tasksArray.length && taskBadge'
            :color='taskBadge.color'
            :content='taskBadge.content'
            :offset-x='8'
          ></v-badge>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Tasks</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'Profile' }">
        <v-list-item-action>
          <v-icon color='info'>mdi-account-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Profile</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :to="{ name: 'Logout' }">
        <v-list-item-action>
          <v-icon color='info'>mdi-exit-to-app</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: 'wc-user-menu',
  props: {
    tasksArray: {
      required: false,
      type: Array
    },
    taskBadge: {
      required: false,
      type: Object
    }
  }
}
</script>
